import { axiosInstance } from '../utils/axios';

export const getTopicTags = extraData =>
  axiosInstance.get('/onboarding/follow', {
    ...extraData,
    params: {
      ...extraData?.params,
      refresh: Math.random(),
    },
  });

export const postTopicTags = selectedTags =>
  axiosInstance.post('/onboarding/follow', selectedTags);
